import { Howl } from 'howler';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as debug from 'debug';

const log = debug('edg:core:sounds-service');

export class Sound {
  path: string;
  name: string;
  loop?: boolean;
}

export class LoadedHowls {
  [key: string]: Howl;
}

export class SoundsService {
  public soundEnabled = true;
  public howls: LoadedHowls = {};

  private _storageKey: string = 'edg-sounds';

  private _enabled: Subject<boolean>;
  onEnabled$: Observable<boolean>;

  private _loadedSounds: Subject<LoadedHowls> = new BehaviorSubject({});
  onSoundsLoaded$: Observable<LoadedHowls> = this._loadedSounds.asObservable();

  _volume: number = null;
  set volume(volume: number) {
    this._volume = volume;
    localStorage.setItem('volume', volume.toString());
  }
  get volume() {
    if (this._volume === null) {
      this._volume = Number(localStorage.getItem('volume') || 0.5);
    }
    return this._volume;
  }

  constructor() {
    const value = localStorage.getItem(this._storageKey);
    this.soundEnabled = value === 'true' || value === null;

    this._enabled = new BehaviorSubject(this.soundEnabled);
    this.onEnabled$ = this._enabled.asObservable();
  }

  public init(context: Sound[], clones?: number) {
    context.forEach((sound: Sound) => {
      this.howls[sound.name] = new Howl({
        src: [sound.path],
      });
    });
    this._loadedSounds.next(this.howls);
  }

  public play(name: string, forcePlay: boolean = null) {
    if (this.howls.hasOwnProperty(name) && (this.soundEnabled || forcePlay)) {
      this.howls[name].volume(this.volume);
      this.howls[name].play();
    }
  }

  public loop(name: string) {
    if (this.howls.hasOwnProperty(name)) {
      this.howls[name].loop(true);
      this.play(name);
    }
  }

  public get(name: string): Howl {
    if (this.howls.hasOwnProperty(name)) {
      return this.howls[name];
    }
    return null;
  }

  public mute(name: string, mute: boolean): void {
    if (this.howls.hasOwnProperty(name)) {
      this.howls[name].mute(mute);
    }
  }

  public toggleSounds(): void {
    this.soundEnabled = !this.soundEnabled;
    localStorage.setItem(this._storageKey, this.soundEnabled.toString());
    this._enabled.next(this.soundEnabled);
  }

  public stop(name: string): void {
    if (this.howls.hasOwnProperty(name)) {
      this.howls[name].stop();
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/sounds.service.ts